<div class="kt-section">
	<div class="kt-section__content">
		<div class="modal-header">
			<h4 class="modal-title">
				{{ 'FE.ORDER.FORMS.HTML.TITLE.ADDADDRESSTOPERSON.SIMILARITY.MODAL.TITLE' | localize }}

			</h4>
			<button type="button" class="close" aria-label="Close" (click)="modalClose()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body dekstop-d mobile-d">
			<div class="row">
				<div class="col-md-12">
					<table class="table table-striped responsive similarity-table" wt-responsive-table>
						<thead>
							<tr>
								<th width="50">
									#
								</th>
								<th width="200">
									{{ 'FE.ORDER.FORMS.GRID.ADDADDRESSTOPERSON.SIMILARITY.ADDRESSNAME' | localize }}
									
								</th>
								<th width="500">
									{{ 'FE.ORDER.FORMS.GRID.ADDADDRESSTOPERSON.SIMILARITY.FULLADDRESS' | localize }}
									
								</th>
								<th width="100">
									{{ 'FE.ORDER.FORMS.GRID.ADDADDRESSTOPERSON.SIMILARITY.SIMILARITYPERCENT' | localize }}
									
								</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let adres of (_data.addressList)">
								<td width="50">
									<!--<mat-radio-button class="modal-radio-button"name="adres"[(ngModel)]="adres"></mat-radio-button>-->
									<label class="kt-radio kt-radio--bold kt-radio--brand">
										<input type="radio"
											   name="adres"
											   [value]="adres"
											   [(ngModel)]="selectedSimilarityAdress">
										<span></span>
									</label>
								</td>
								<td width="200">
									{{adres.name}}
								</td>
								<td width="500">
									{{adres.fullAddress}}
								</td>
								<td width="100">
									{{adres.percent}}
								</td>
							</tr>

						</tbody>
					</table>
				</div>
			</div>

			<!--<div class="kt-widget5" *ngFor="let adres of (_data.addressList)">
				<div class="kt-widget5__item ng-star-inserted">



					<label class="kt-radio kt-radio--bold kt-radio--brand">
						<input type="radio"
							   name="adres"
							   [value]="adres"
							   [(ngModel)]="selectedSimilarityAdress">
						<span></span>
					</label>
					<div class="kt-widget5__content">
						<div class="kt-widget5__section">
							<div class="kt-widget5__stats">
								<span class="kt-widget5__sales text-center">Adres Adı</span>
								<span class="kt-widget5__number">{{adres.name}}</span>
							</div>
						</div>
					</div>
					<div class="kt-widget5__content">
						<div class="kt-widget5__stats">
							<span class="kt-widget5__sales text-center">Açık Adres</span>
							<span class="kt-widget5__number">{{adres.fullAddress}}</span>
						</div>
						<div class="kt-widget5__stats">
							<span class="kt-widget5__votes text-center">Benzerlik</span>
							<span class="kt-widget5__number text-success text-center">{{adres.percent}}</span>
						</div>
					</div>
				</div>
			</div>-->
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-danger" (click)="btnNoAddressAffinity()">
				{{ 'FE.ORDER.FORMS.GRID.BUTTON.ADDADDRESSTOPERSON.SIMILARITY.NOSIMILARITY' | localize }}
			</button>
			<!--<button type="button" class="btn btn-secondary" (click)="modalClose()">Kapat</button>-->
			<button type="button" class="btn btn-primary" (click)="btnChooseAddress()">
				{{ 'FE.ORDER.FORMS.GRID.BUTTON.ADDADDRESSTOPERSON.SIMILARITY.SELECTADDRESS' | localize }}
			</button>
		</div>

	</div>
</div>

